import { FormItem, FormItems, Select, WideTextInput } from 'components/ColumnForm'
import PlanTypeSelect from 'components/PlanTypeSelect'
import type { InsuranceProvider } from 'types'
import states from 'utils/states'

type PayerDetailsFormProps = {
  payerForm: InsuranceProvider
  updatePayerForm: (update: InsuranceProvider) => void
}

const PayerDetailsForm = ({ payerForm, updatePayerForm }: PayerDetailsFormProps): JSX.Element => (
  <FormItems data-testid="PayerDetailForm">
    <FormItem data-test-row="bin">
      <p>BIN</p>
      <WideTextInput value={payerForm.bin} onChange={e => updatePayerForm({ ...payerForm, bin: e.target.value })} />
    </FormItem>
    <FormItem data-test-row="pcn">
      <p>PCN</p>
      <WideTextInput value={payerForm.pcn} onChange={e => updatePayerForm({ ...payerForm, pcn: e.target.value })} />
    </FormItem>
    <FormItem data-test-row="name">
      <p>Payer Name</p>
      <WideTextInput value={payerForm.name} onChange={e => updatePayerForm({ ...payerForm, name: e.target.value })} />
    </FormItem>
    <FormItem data-test-row="code">
      <p>Group</p>
      <WideTextInput value={payerForm.group} onChange={e => updatePayerForm({ ...payerForm, group: e.target.value })} />
    </FormItem>
    <FormItem data-test-row="plan">
      <p>Plan Type</p>
      <PlanTypeSelect value={payerForm.planType} onChange={planType => updatePayerForm({ ...payerForm, planType })} />
    </FormItem>
    <FormItem data-test-row="plan-name">
      <p>Plan Name</p>
      <WideTextInput
        value={payerForm.planName}
        onChange={e => updatePayerForm({ ...payerForm, planName: e.target.value })}
      />
    </FormItem>
    <FormItem data-test-row="billing-type">
      <p>Billing Type</p>
      <Select
        data-testid="billing-type"
        multiple={false}
        value={payerForm.billing?.defaultType}
        placeholder={'Select billing type...'}
        options={['Any', 'Primary', 'Secondary', 'Tertiary']}
        onChange={([option]) =>
          updatePayerForm({
            ...payerForm,
            billing: { ...payerForm.billing, defaultType: option ? option.value : '' },
          })
        }
        disableClear
      />
    </FormItem>
    <FormItem data-test-row="status">
      <p>Status</p>
      <Select
        data-testid="status"
        multiple={false}
        value={payerForm.status}
        placeholder={'Select status...'}
        options={['In Network', 'Out of Network']}
        onChange={([option]) => updatePayerForm({ ...payerForm, status: option ? option.value : '' })}
        disableClear
      />
    </FormItem>
    <FormItem data-test-row="state-code">
      <p>State Code</p>
      <Select
        data-testid="state-code"
        multiple={false}
        value={payerForm.stateCode}
        placeholder={'Select state code...'}
        options={states}
        onChange={([option]) => updatePayerForm({ ...payerForm, stateCode: option ? option.value : '' })}
        disableClear
      />
    </FormItem>
  </FormItems>
)

export default PayerDetailsForm
